<template>
    <div class="nav_top">
        <div class="hamburger">
            <img :src="logo_small">
        </div>
        <el-menu class = "nav_top_bar" :default-active="$route.path" mode="horizontal" text-color="#333" active-text-color="#eb662b" router @select="handleSelect">
            <el-menu-item :index="'/homepage'" >首页</el-menu-item>
            <el-submenu
              index="product"
              popper-class="product-submenu-pop"
            >
              <template slot="title">
                数字供应链服务
              </template>
              <div class="pop-container" style="display: flex;padding-bottom: 10px;">
                <div class="pop-column" style="width: 280px;">
                  <h3 class="col-header" @click="jumpRouter(1)">物流数字化  无纸化服务</h3>
                  <div class="split-line"></div>
                  <div style="display: flex;">
                    <div class="col-link textLinkL" style="width: 60%;" @click="jumpRouter(2)">智能运输管理(TMS)</div>
                    <div class="col-link textLinkR" style="width: 40%;" @click="jumpRouter(3)">物流全程无纸化</div>
                  </div>
                </div>
                <div class="pop-column" style="width: 260px;">
                  <h3 class="col-header" @click="jumpRouter(4)">货物跟踪可视化服务</h3>
                  <div class="split-line"></div>
                  <div style="display: flex;">
                    <div class="col-link textLinkL" @click="jumpRouter(5)">提送货预约管理</div>
                    <div class="col-link textLinkR" @click="jumpRouter(6)">在途可视化跟踪</div>
                  </div>
                </div>
                <div class="pop-column" style="width: 320px;">
                  <h3 class="col-header" @click="jumpRouter(7)">企业管理数据化驾驶舱</h3>
                  <div class="split-line"></div>
                  <div style="display: flex;">
                    <div class="col-link textLinkL" @click="jumpRouter(8)">日常运营管理数据化</div>
                    <div class="col-link textLinkR" @click="jumpRouter(9)">企业经营决策数据化</div>
                  </div>
                </div>
              </div>
            </el-submenu>
            <el-submenu v-for="(item,index) in $router.options.routes" :key="index" :index="item.redirect" 
            v-if="item.meta.title != '首页' && item.meta.title != '数字供应链服务' && item.meta.title != '服务与支持' && item.meta.title != '关于我们' && 
            !item.hidden">
                <template slot="title">{{item.meta.title}}</template>
                <el-menu-item v-for="element in item.children" :key="element.path" :index="element.path" >{{element.meta.title}}</el-menu-item>
            </el-submenu>
            <el-menu-item :index="'/support'" >服务与支持</el-menu-item>
            <el-menu-item :index="'/aboutUsUs'" >关于我们</el-menu-item>
        </el-menu>
        <div class="button_login" @click="external()">登录</div>
        <!-- <div class="nav_top_operating">
            <el-dropdown style="float:right;" trigger="click" @command="roleHandle">
                <span class="el-dropdown-link">
                    {{userName}}
                    <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="Center">个人中心</el-dropdown-item>
                    <el-dropdown-item command="Login">退出</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div> -->
    </div>
</template>

<script>
export default {
  // inject:['reload'],
  name: "nav-top-bar",
  data() {
    return {
      logo_small: require("./../../static/footer/logo.png"),
      userName: sessionStorage.userName
    };
  },
  created(){
    console.log(this.$route.path)
  },
  methods: {
    roleHandle(val) {
      this.$router.push({ name: val });
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    external () {
      window.open('https://qiye.wlyuan.com.cn', '_self');
      // window.open('https://www.wlyuan.com.cn/#/notice', '_self');
    },
    jumpRouter (type) {
      let router = {
        name:null,
        query: {}
      }
       switch (type) {
          case 1:
            router.name = 'scheme-Management'
            break;
          case 2:
            router.name = 'scheme-Management'
            break;
          case 3:
            router.name = 'scheme-Paperless'
            break;
          case 4:
            router.name = 'scheme-Visual'
            break;
          case 5:
            router.name = 'scheme-Visual'
            router.query = {scrollType:5}
            break;
          case 6:
            router.name = 'scheme-Visual'
            router.query = {scrollType:6}
            break;
          case 7:
            router.name = 'scheme-Digitization'
            break;
          case 8:
            router.name = 'scheme-Digitization'
            router.query = {scrollType:8}
            break;
          case 9:
            router.name = 'scheme-Digitization'
            router.query = {scrollType:9}
            break;
      }
      this.$router.push({ name: router.name, query: router.query })
    }
  },
  components:{
  }
};
</script>
<style lang="scss">
/* 展开时箭头旋转 */
/deep/.el-submenu.is-opened .el-icon-arrow-down {
  transform: rotate(180deg);
}

/* ========== 关键：深度修改submenu弹出层样式 ========== */
/deep/.product-submenu-pop.el-menu--popup {
  min-width: 1260px;
  padding: 32px 40px !important;
  background-color: #f0f2f6;
  border-radius: 0;
}
/* 清除element原生子菜单默认padding和边框 */
/deep/.product-submenu-pop.el-menu--popup .el-menu {
  padding: 0 !important;
  border: none;
}
/deep/.pop-container {
  display: flex;
  gap: 64px;
}
.header-main-nav {
  border-bottom: none;
}
.el-icon-arrow-down {
  margin-left: 4px;
  font-size: 12px;
  transition: transform 0.2s;
}
.pop-column {
  min-width: 130px;
  margin-right: 60px;
  overflow: hidden;
}
.col-header {
  font-size: 20px;
  font-weight: 400;
  margin: 0 0 10px;
  text-align: center;
  cursor: pointer;
}
.col-header:hover {
  color: #EB662B;
}
.split-line {
  width: 100%;
  height: 1px;
  border-bottom: 1px solid rgb(188, 190, 194);
  margin-bottom: 16px;
}
.col-link {
  width: 50%;
  font-size: 16px;
  color: #666666;
  line-height: 2.3;
  cursor: pointer;
}
.col-link:hover {
  color: #EB662B;
}
.textLinkL {
  text-align: left;
}
.textLinkR {
  text-align: right;
}
.nav_top {
  
}
</style>



// WEBPACK FOOTER //
// src/components/NavTopBar.vue